import React from "react";
import settings from "../../config/settings.json";
import "./Footer.css";

const Footer = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return (
        <footer className="app-footer">
            ©{currentYear}, {settings.env.ORGANIZATION}
        </footer>
    )
};

export default Footer;